import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ViewerComponent implements OnInit {

  @Input() product: any;
  //model-viewer
  public src;
  public placement;
  public iosSrc;

  @ViewChild('model-viewer') textarea: ElementRef;

  constructor() { }

  ngOnInit(): void {
    this.src = `./assets/products/${this.product.babylon}`;
    this.iosSrc = this.product.ios_src ? `./assets/products/${this.product.ios_src}` : null;
    this.placement = "wall";
  }

  ngAfterViewInit() {
    const modelViewerTexture: any = document.getElementById("model-viewer");
    if (this.product.texture) {
      modelViewerTexture.addEventListener("load", () => {
        const material = modelViewerTexture.model.materials[0].pbrMetallicRoughness;
        modelViewerTexture.createTexture(`./assets/images/textures/${this.product.texture}`).then(text =>
          material.baseColorTexture.setTexture(text));
      });
    }
  }

}
